// extracted by css-extract-rspack-plugin
export default {"todoContainer":"nXp6_","todoHeader":"G6g_l","primaryColor":"PAHpD","todoItem":"hmD9M","statusIndicator":"wTPEO","pendingIndicator":"X8O8H"};